import { render, staticRenderFns } from "./messageLogs.vue?vue&type=template&id=9c530fbc&"
import script from "./messageLogs.vue?vue&type=script&lang=js&"
export * from "./messageLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports